import script from "./DPO.vue?vue&type=script&lang=js"
export * from "./DPO.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__